import store from '@/store'

function optionExtend (options) {
  if (store.state.user.token) {
    options.headers.Authorization = 'OPS ' + store.state.user.token
  }
  if (store.state.user.defaultTenant) {
    options.headers.DefaultTenant = store.state.user.defaultTenant
  }
  if (store.state.user.selTenants.length) {
    options.headers.SelTenants = store.state.user.selTenants
  }
  if (options.needPrivateCloudProjectHeader) {
    let projectId = store.state.privateCloud.selPrivateCloudProject
    if (projectId) {
      options.headers.PrivateCloudProject = projectId
    }
  }
  return options
}

export default optionExtend
